import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getLocalStorage } from "@/utils/localStorage";
import { fullscreenLoading } from "@/utils/loading";
import { useRoute } from "vue-router";
import { getUserInfo } from "@/api/user";
import { useStore } from "vuex";
import { watch, reactive } from "vue";
// import { messageError } from '@/utils/message';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

//网站标题
document.title = process.env.VUE_APP_TITLE;

let route = reactive(useRoute());
console.log('route1',route)
const store = useStore();
console.log('store1',store)
if (getLocalStorage("Authorization")) {
  store.dispatch("user/setUserInfo");
  store.dispatch("menu/setNavList");
}

//监听路由变化打开标签
watch(
  () => route.path,
  (newVal, oldVal) => {
    if (route.name == "404") return;
    if (route.meta.authentication && route.meta.keepAlive) {
      store.commit(
        "menu/addTabList",
        Object.assign(route.meta, { path: route.path })
      );
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView))
}
}

})